import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactFCV } from '@types';

import { IAirDeliveryForbiddenMessages } from '../../model';

import { StyledAirDeliveryForbidden, StyledIconSolidPlane } from './styled';

export const AirDeliveryForbidden: ReactFCV<IAirDeliveryForbiddenMessages> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <StyledAirDeliveryForbidden>
      <StyledIconSolidPlane viewBox="0 0 24 24" />
      <FormattedMessage {...message} />
    </StyledAirDeliveryForbidden>
  );
};
